import React from 'react';
import uuidv4 from "../../utils/uuidv4";
/**
 * Bronson UploadContainer component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-upload-container.html
 * @constructor
 */
export function UploadContainer({ children, upload, uploadItemsLabel, testId, ...otherProps }) {
    const uploadItemListTitleId = uuidv4('upload-itemlist-title-');
    return (React.createElement("div", { className: "c-upload-container" },
        React.createElement("div", { className: "c-upload-container__field" }, upload),
        React.Children.count(children) > 0 && (React.createElement(React.Fragment, null,
            React.createElement("span", { id: uploadItemListTitleId, className: "c-upload-container__itemlist-title" }, uploadItemsLabel),
            React.createElement("ul", { ...otherProps, "data-testid": testId, className: "c-upload-container__itemlist", "aria-labelledby": uploadItemListTitleId }, children)))));
}
UploadContainer.displayName = 'UploadContainer';
/**
 * Bronson UploadContainerItem component (nested).
 * @constructor
 */
function UploadContainerItem({ children }) {
    return React.createElement("li", { className: "c-upload-container__item" }, children);
}
UploadContainerItem.displayName = 'UploadContainer.Item';
UploadContainer.Item = UploadContainerItem;
